import { useQuery } from "react-query";
import { getMotionCensor } from "../../../../actions/CarrierAgreementMgmt/Security";

export const useMotionCensor = () => {
  const { data, isLoading, refetch } = useQuery(
    "GetMotionCensor",
    getMotionCensor,
    {
      refetchOnWindowFocus: false,
    }
  );

  return { data, isLoading, refetch };
};
